import { AxiosError } from 'axios'
import { store } from '../../app/store'
import * as Constants from '../../constants'
import APIClient from '../../apiClient'
import StatusE from '../../types/statusE'
import { TokenT } from '../../types/tokenT'
import Token from '../../token'
import { setError, setIsLoggedIn, setStatus } from './slice'
import { OAuthErrorT } from '../../types/oAuthErrorT'

const apiClient = new APIClient(false)
const apiInstance = apiClient.getInstance()

export default (authorizationCode: string) => (dispatch: typeof store.dispatch) => {
  dispatch(setStatus(StatusE.LOADING))

  if (authorizationCode) {
    const requestData = new URLSearchParams()
    requestData.append('grant_type', 'authorization_code')
    requestData.append('code', authorizationCode)
    requestData.append('client_id', process.env.REACT_APP_OAUTH_CLIENT_ID ?? '')
    apiInstance
      .post<TokenT>(`/oauth/token`, requestData)
      .then(async (response) => {
        const grantedScopes = response.data.scope?.split(/ +/).filter(Boolean) ?? []
        const hasAllScopesInResponse = Constants.LOGIN_SCOPES_ARRAY.every((scope) =>
          grantedScopes.includes(scope)
        )

        if (!hasAllScopesInResponse) {
          const hasNotificationAccess = await Token.grantsNotificationAccess(
            response.data.access_token
          )
          if (!hasNotificationAccess) {
            const grantedLabel = grantedScopes.length > 0 ? grantedScopes.join(', ') : 'none'
            dispatch(
              setError({
                error: 'insufficient_scope',
                error_description:
                  `Your login token is missing notification permissions (granted: ${grantedLabel}). ` +
                  'An administrator must add notification:subscribe and notification:consume to the ' +
                  'sandbox Member Portal OAuth client in WordPress, then you can sign in again.',
              })
            )
            return
          }
        }

        const tokenToStore = Token.normalizeTokenScopes(response.data)

        localStorage.setItem(
          Constants.GTOB_TOKEN_EXPIRATION_IDENTIFIER,
          (new Date().getTime() + tokenToStore.expires_in * 1000).toString()
        )
        localStorage.setItem(
          Constants.GTOB_TOKEN_LONG_EXPIRATION_IDENTIFIER,
          (new Date().getTime() + Constants.LONG_EXPIRATION_TIME * 1000).toString()
        )
        localStorage.setItem(Constants.GTOB_TOKEN_IDENTIFIER, JSON.stringify(tokenToStore))

        dispatch(setIsLoggedIn(true))
      })
      .catch((error: AxiosError<OAuthErrorT>) => {
        dispatch(setError(error.response?.data))
      })
  }
}
